
(function () {
  if (customElements.get('silo-makes-good')) return;

  const DURATION = 1800;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /** Split "720$" / "$125" / "36%" / "3x" / "94lbs" into prefix + number + suffix. */
  function parse(raw) {
    const text = String(raw == null ? '' : raw).trim();
    let prefix = '';
    let suffix = '';

    if (text.startsWith('$')) {
      prefix = '$';
    } else if (text.includes('$')) {
      suffix = '$';
    } else if (text.endsWith('%')) {
      suffix = '%';
    } else if (text.endsWith('x')) {
      suffix = 'x';
    } else if (text.includes('lbs')) {
      suffix = 'lbs';
    }

    const number = parseFloat(text.replace(/[^0-9.]/g, '')) || 0;
    return { raw: text, prefix, suffix, number, zero: prefix + '0' + suffix };
  }

  class SiloMakesGood extends HTMLElement {
    connectedCallback() {
      this._stats = Array.from(this.querySelectorAll('.statistic-value')).map((el) => ({
        el,
        raf: null,
        ...parse(el.dataset.value),
      }));
      if (!this._stats.length) return;

      // Reduced motion: jump straight to the final values, no observer, no animation.
      if (reducedMotion.matches) {
        this._stats.forEach((s) => { s.el.textContent = s.raw; });
        return;
      }

      this._stats.forEach((s) => { s.el.textContent = s.zero; });

      this._observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            this._observer.unobserve(entry.target);
            const stat = this._stats.find((s) => s.el === entry.target);
            if (stat) this._animate(stat);
          }
        },
        { threshold: 0.2 }
      );

      this._stats.forEach((s) => this._observer.observe(s.el));
    }

    disconnectedCallback() {
      if (this._observer) {
        this._observer.disconnect();
        this._observer = null;
      }
      if (this._stats) {
        this._stats.forEach((s) => {
          if (s.raf) cancelAnimationFrame(s.raf);
          s.raf = null;
        });
      }
    }

    _animate(stat) {
      let start = null;
      const tick = (now) => {
        if (start === null) start = now;
        const progress = Math.min((now - start) / DURATION, 1);
        stat.el.textContent = stat.prefix + Math.floor(progress * stat.number) + stat.suffix;
        if (progress < 1) {
          stat.raf = requestAnimationFrame(tick);
        } else {
          stat.el.textContent = stat.raw; // exact final text (preserves any formatting)
          stat.raf = null;
        }
      };
      stat.raf = requestAnimationFrame(tick);
    }
  }

  customElements.define('silo-makes-good', SiloMakesGood);
})();
